import script from "./InstallAppBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstallAppBanner.vue?vue&type=script&lang=ts&setup=true"

import "./InstallAppBanner.vue?vue&type=style&index=0&id=30daef62&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30daef62"]])

export default __exports__